import { registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { UIManager } from "../../../UI/UI/UIManager";
import { ButtonTemplate } from "../Templates/DataTypeTemplates/ButtonTemplate";
import { Column } from "./Column";

export class ButtonColumn extends Column {
    //#region Fields
    protected override _itemTemplate: ButtonTemplate;
    //#endregion Fields

    //#region Properties
    /** Funkce, která má být spuštěna po kliknutí na tlačítko */
    public action: (id: string) => void;

    public set buttonLocKey(value: string) {
        this.itemTemplate.setButtonLocalization(value);
    }

    public override get itemTemplate(): ButtonTemplate {
        return this._itemTemplate;
    }

    public override set itemTemplate(v: ButtonTemplate) {
        this._itemTemplate = v;
    }

    //#endregion Properties

    //#region Methods

    //#endregion Methods

    //#region HTMLElement
    protected override _constructor(): void {
        super._constructor();

        this.itemTemplate = new ButtonTemplate();
        //this.editItemTemplate = new DefaultEditTemplate();

        this.id = UIManager.instance.generateElementID() + "_col"; // U sloupců z definice se o to stará ColumnFactory přes metodu initialize()

        this.addEventListener("buttonClicked", (event: CustomEvent) => this.action(event.detail.id));
    }
    //#endregion HTMLElement
}

registerCustomElement("tsc-buttoncolumn", ButtonColumn);
